<template>
  <v-overlay v-model="props.enable" class="d-flex justify-center align-center">
    <v-progress-circular indeterminate color="red" size="160" width="16"/>
  </v-overlay>
</template>

<script setup>
const props = defineProps({
  enable: Boolean
});

</script>

<style scoped>

</style>
